// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"35":"54894efd","93":"31d6cfe0","174":"a2eab8c1","837":"792a61c5","971":"c0235938"}[chunkId] + ".chunk.css";
};